module.exports = __webpack_public_path__ + "img/shield.6a1ccd91.6a1ccd91.svg";